// Base used for public, client-shareable links (order tracking + product specs).
// Always the production domain so links work when shared, regardless of where
// the app is currently running (preview vs prod). Configurable via env.
export const PUBLIC_WEB_BASE = (
  process.env.REACT_APP_PUBLIC_WEB_URL ||
  (typeof window !== "undefined" ? window.location.origin : "")
).replace(/\/$/, "");

export const trackingUrl = (orderId) => `${PUBLIC_WEB_BASE}/track/${orderId}`;
export const specsUrl = (productId) => `${PUBLIC_WEB_BASE}/specs/${productId}`;
